import React from 'react';

const SelectivateLogo = ({ variant = 'default', size = 'medium', className = '' }) => {
  // Size mappings for different size options
  const sizes = {
    small: { fontSize: '1.2rem', height: '24px' },
    medium: { fontSize: '1.8rem', height: '36px' },
    large: { fontSize: '2.5rem', height: '48px' },
    extraLarge: { fontSize: '3.5rem', height: '64px' }
  };
  
  const currentSize = sizes[size] || sizes.medium;
  
  // Style for the logo container
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    height: currentSize.height,
    ...({ small: { gap: '2px' }, medium: { gap: '3px' }, large: { gap: '4px' }, extraLarge: { gap: '6px' } }[size] || { gap: '3px' })
  };
  
  // Style for the "S" letter - highlighted in orange
  const sStyle = {
    color: '#F5821F',
    fontWeight: '700',
    fontSize: currentSize.fontSize,
    lineHeight: 1
  };
  
  // Style for the rest of the text
  const restStyle = {
    color: variant === 'white' ? '#FFFFFF' : '#E0E0E0',
    fontWeight: '600',
    fontSize: currentSize.fontSize,
    lineHeight: 1
  };
  
  // For the circular version
  if (variant === 'circle') {
    // Smaller font size for circle variant to fit within inner circle
    const circleStyle = {
      color: '#F5821F',
      fontWeight: '700',
      fontSize: size === 'large' ? '1.8rem' : currentSize.fontSize,
      lineHeight: 1
    };
    
    const circleRestStyle = {
      color: variant === 'white' ? '#FFFFFF' : '#E0E0E0',
      fontWeight: '600',
      fontSize: size === 'large' ? '1.8rem' : currentSize.fontSize,
      lineHeight: 1
    };
    
    return (
      <div className={className} style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '220px'
      }}>
        <div style={{...containerStyle, gap: '2px'}}>
          <span style={circleStyle}>S</span>
          <span style={circleRestStyle}>ELECTIVATE</span>
        </div>
        <p style={{
          color: '#CCCCCC',
          fontSize: '0.75rem',
          marginTop: '6px',
          textAlign: 'center'
        }}>
          SAP Implementation Platform
        </p>
      </div>
    );
  }
  
  // For the banner version
  if (variant === 'banner') {
    return (
      <div className={className} style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <div style={containerStyle}>
          <span style={sStyle}>S</span>
          <span style={restStyle}>ELECTIVATE</span>
        </div>
        <p style={{
          color: '#CCCCCC',
          fontSize: '1.1rem',
          marginTop: '4px',
          textAlign: 'center'
        }}>
          SAP Implementation Platform
        </p>
      </div>
    );
  }
  
  // Default inline logo
  return (
    <div className={className} style={containerStyle}>
      <span style={sStyle}>S</span>
      <span style={restStyle}>ELECTIVATE</span>
    </div>
  );
};

export default SelectivateLogo;